import { RealTimeEventTypes } from '@/enums/RealTimeEventTypes'
import type { IChargerConnectivityStatusMessage } from '@/models/Chargers/IChargerConnectivityStatusMessage'
import type { IChargerSimStatusMessage } from '@/models/Chargers/IChargerSimStatusMessage'
import type { IDeviceStatusChangeMessage } from '@/models/Chargers/IDeviceStatusChangeMessage'
import { type EventHandler, type IRealtimeEventService, RealTimeEventService } from '@/service/RealTimeEvents/RealTimeEventService'
import { injectable } from 'inversify'

export interface IChargerRealTimeEventService extends IRealtimeEventService {}

@injectable()
export class ChargerRealTimeEventService extends RealTimeEventService implements IChargerRealTimeEventService {
  constructor(hub: string = 'charger') {
    super(hub)
  }

  buildConnection() {
    super.buildConnection()
    this.connection.on('ChargerConnectivityStatusChangedEventAsync', this.onChargerConnectivityStatusChangedEvent.bind(this))
    this.connection.on('ChargerSimStatusChangedEventAsync', this.onChargerSimStatusChangedEvent.bind(this))
    this.connection.on('DeviceStatusChangedEventAsync', this.onDeviceStatusChangedEvent.bind(this))
  }

  async onChargerConnectivityStatusChangedEvent(connectivityStatusMessage: IChargerConnectivityStatusMessage): Promise<void> {
    this.eventHandlers
      .filter(eh => eh.eventType === RealTimeEventTypes.ChargerConnectivityStatusChangedEvent)
      .forEach(async (eventHandler: EventHandler<IChargerConnectivityStatusMessage>) => {
        await eventHandler.handle(connectivityStatusMessage)
      })
  }

  async onChargerSimStatusChangedEvent(simStatusMessage: IChargerSimStatusMessage): Promise<void> {
    this.eventHandlers
      .filter(eh => eh.eventType === RealTimeEventTypes.ChargerSimStatusChangedEvent)
      .forEach(async (eventHandler: EventHandler<IChargerSimStatusMessage>) => {
        await eventHandler.handle(simStatusMessage)
      })
  }

  async onDeviceStatusChangedEvent(deviceStatusMessage: IDeviceStatusChangeMessage): Promise<void> {
    this.eventHandlers
      .filter(eh => eh.eventType === RealTimeEventTypes.DeviceStatusChangedEvent)
      .forEach(async (eventHandler: EventHandler<IDeviceStatusChangeMessage>) => {
        await eventHandler.handle(deviceStatusMessage)
      })
  }
}
